var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.047,
    viewBox: "0 0 18 18.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{fill:#0d0d0d;font-size:4px;font-family:Arial-BoldMT, Arial;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(288 104)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.772 102.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.446,2H5.655A1.655,1.655,0,0,0,4,3.655V16.892a1.655,1.655,0,0,0,1.655,1.655h9.928a1.655,1.655,0,0,0,1.655-1.655v-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,2V7.791h5.791",
    transform: "translate(-1.554)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(294 116)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ZIP")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaZipIcon);
export default __webpack_public_path__ + "static/media/media-zip-icon.2273ebaee9cf55bacf25e4a471902733.svg";
export { ForwardRef as ReactComponent };